import React, { useEffect } from 'react'
import { useHistory } from 'react-router'
import { useAuth } from '../../hooks/auth'

const Home: React.FC = () => {
  const { userIsLogged } = useAuth()
  const history = useHistory()

  useEffect(() => {
    if (userIsLogged()) {
      history.push('/schedule')
    } else {
      history.push('/login')
    }
    // eslint-disable-next-line
  }, [])

  return (
    <div></div>
  )
}

export default Home;
